import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { contractFormReducer } from "./Reducers/contractformdata";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { thunk } from "redux-thunk";
import { sidebartabReducer } from "./Reducers/sidebarButtons";
import { responseReducer } from "./Reducers/dataResponse";
import { buttonLoaderReducer } from "./Reducers/buttonClicks";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [""],
};

const rootReducer = combineReducers({
  contractresponse: contractFormReducer,
  sidebartabs: sidebartabReducer,
  userdata: responseReducer,
  buttonstatus: buttonLoaderReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), thunk],
});

export const persistor = persistStore(Store);

export const resetStore = async () => {
  await persistor.purge(); // Clears the persisted state
};
